module.exports = __webpack_public_path__ + "assets/public/imgs/openshift-service-on-aws-logo.svg";